<script lang="ts">
    
    import { createEventDispatcher, getContext } from "svelte";
    import type { SaveGame } from "../../global";
    import type { InfoActivity } from "../../Model/InfoActivity";
    import { addPoints } from "../../Services/game";
    import ActiviyModal from "../Shared/ActiviyModal.svelte";
    import AudioPlayer from "../Shared/AudioPlayer.svelte";
    import WinScreen from "../Shared/WinScreen.svelte";
    import ContentItem from "./ContentItem.svelte";

    export let activity: InfoActivity;

    const saveGame: SaveGame = getContext('saveGame');
    const dispatch = createEventDispatcher();

    let showWinScreen = false;

    function onClose(): void {
        //Si la actividad ya estaba completada previamente
        //simplemente emitimos el evento de cierre de actividad
        if (activity.isCompleted.value) {
            dispatch('close');
            return;
        }
        //La actividad no estaba completada previamente
        //La marcamos como completada y mostramos el
        //modal de victoria
        activity.setCompleted();
        saveGame();
        addPoints(activity.points.win);
        showWinScreen = true;
    }

    function onContinue(): void {
        dispatch('close');
    }

</script>

<ActiviyModal on:close={onClose} title={activity.title}>
    
    <AudioPlayer src={activity.audio} />

    {#each activity.content as content}
        <ContentItem {content} />
    {/each}

</ActiviyModal>

{#if showWinScreen}
    <WinScreen points={activity.points.win} on:continue={onContinue} />
{/if}
